import React, { useCallback, useMemo, useState } from "react";
import { TCText } from "../../TCText/TCText";
import { Button } from "../../button/Button";
import { Colors } from "../../../utils/colors";
import { Strings } from "../../../utils/strings";
import { UltraServiceLocations } from "../../../utils/data";
import { ServiceLocation } from "./ServiceLocation";
import { ComingSoonBar } from "./ComingSoonBar";

type props = {
  visible: boolean;
  onConfirm: (locationId: number) => void;
  onClose: () => void;
  description?: string;
};

export const ServiceLocationModal: React.FC<props> = ({
  visible,
  onConfirm,
  onClose,
  description,
}) => {
  const [selectedLocation, setSelectedLocation] = useState<number>();

  const enabledLocations = useMemo(() => {
    return UltraServiceLocations.filter((loc) => loc.isEnabled);
  }, []);

  const disabledLocations = useMemo(() => {
    return UltraServiceLocations.filter((loc) => !loc.isEnabled);
  }, []);

  const onCancel = useCallback(() => {
    setSelectedLocation(undefined);
    onClose();
  }, [onClose]);

  return visible ? (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1002,
      }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 16,
          padding: "20px 12px",
          display: "flex",
          justifyContent: "space-between",
          width: "90%",
          maxWidth: "380px", // Added max width for desktop/full screen view
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          flexDirection: "column",
          minHeight: "fit-content",
          maxHeight: "90vh",
          overflow: "auto",
          position: "relative",
        }}>
        <TCText
          style={{
            fontWeight: 600,
            fontSize: 16,
            color: "black",
            textAlign: "left",
            marginBottom: 20,
          }}
          value={"Select Location for booking"}
        />

        {enabledLocations.map((location) => {
          return (
            <ServiceLocation
              isSelected={location.id === selectedLocation}
              location={location.name}
              onClick={() => {
                setSelectedLocation(location.id);
              }}
              key={location.id}
            />
          );
        })}

        {disabledLocations.length ? (
          <div>
            <ComingSoonBar />
            {disabledLocations.map((location) => {
              return (
                <ServiceLocation
                  isSelected={false}
                  location={location.name}
                  key={location.id}
                />
              );
            })}
          </div>
        ) : null}

        <div style={{ display: "flex", gap: 5, width: "100%", marginTop: 30 }}>
          <Button
            text={"Cancel"}
            onPress={onCancel}
            btnStyle={{
              width: "100%",
              backgroundColor: "transparent",
              height: 45,
              border: `2px solid ${Colors.darkBrown}`,
            }}
            textStyle={{ color: Colors.darkBrown }}
          />
          <Button
            text={Strings.OK}
            disabled={!selectedLocation}
            onPress={() => {
              onConfirm(selectedLocation ?? 0);
            }}
            btnStyle={{
              width: "100%",
              backgroundColor: Colors.darkBrown,
              height: 45,
            }}
            textStyle={{ color: "white" }}
          />
        </div>
      </div>
    </div>
  ) : null;
};
